import styled from "styled-components";
import { colors } from "../element/elements.js";

export const Styles = styled.div`
  a.nav-sidebar {
    padding: 18px 0 0 10px;

    i {
      font-size: 20px;
      color: ${colors.border1};
    }
  }

  .sidebar {
    background-color: #ffffff;
    padding: 10px;
    height: 100%;
    width: 250px;
    position: fixed;
    top: 0;
    left: -250px;
    right: auto;
    overflow-y: auto;
    z-index: 9999;
    transition: all 400ms cubic-bezier(0.785, 0.135, 0.15, 0.86);
    border-right: 1px solid ${colors.border1};
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

    .side-header {
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 15px;

      .profile {
        display: flex;
        align-items: center;
        gap: 14px;

        .avatar {
          width: 54px;
          height: 54px;
          border-radius: 50%;
          background: ${colors.red_bg};
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
          text-transform: uppercase;
          box-shadow: 0 8px 18px rgba(17, 182, 122, 0.2);
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: transform 0.2s ease;

          &:hover {
            transform: translateY(-2px);
          }

          &.uploading {
            cursor: wait;
            transform: none;
            pointer-events: none;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
            display: block;
          }

          .uploading-indicator {
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.55);
            color: #fff;
            font-size: 11px;
            letter-spacing: 0.08em;
            text-transform: uppercase;
          }
        }

        .meta {
          display: flex;
          flex-direction: column;
          gap: 4px;

          .name {
            font-size: 16px;
            font-weight: 600;
            color: ${colors.black1};
          }

          .role {
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 0.08em;
            color: ${colors.text3};
          }
        }

        .avatar-input {
          display: none;
        }

        .avatar-error {
          flex-basis: 100%;
          margin: 8px 0 0 68px;
          font-size: 12px;
          color: ${colors.red};
        }
      }

      .brand {
        img {
          max-height: 45px;
        }
      }

      .close-btn {
        background: transparent;
        border: 1px solid ${colors.border1};
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: ${colors.red};
        font-size: 18px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background: ${colors.red};
          color: #fff;
          border-color: ${colors.red};
        }
      }
    }

    .side-nav {
      h5 {
        color: ${colors.red};
        text-transform: uppercase;
        font-weight: 300;
        margin-bottom: 18px;
      }

      .nav-heading {
        margin-top: 26px;
      }

      p {
        font-size: 12px;
        color: ${colors.text3};
        line-height: 24px;
        margin-bottom: 16px;
      }

      ul {
        margin: 0;
        padding: 0;
        list-style: none;
      }
    }
  }

  .sidebar.opened {
    left: 0 !important;
  }

  .sidebar.pinned {
    left: 0 !important;
    box-shadow: 6px 0 24px rgba(0, 0, 0, 0.08);

    .side-header {
      .close-btn {
        display: none;
      }
    }
  }

  .sidebar.pinned + .sidebar-overlay {
    display: none !important;
  }

  .sidebar-overlay {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1111;
    visibility: hidden;
    opacity: 0;
    transition: 0.3s ease;
  }

  .sidebar-overlay.visible {
    visibility: visible;
    opacity: 1;
  }

  [data-pinned="true"] {
    a.nav-sidebar {
      display: none;
    }
  }

  .side-nav {
    .nav-heading {
      font-size: 12px;
      letter-spacing: 0.08em;
      color: ${colors.text3};
    }

    ul {
      margin-bottom: 12px;
      padding: 0;
      list-style: none;

      li {
        margin-bottom: 0;
        a.nav-link-btn {
          display: block;
          width: 100%;
          font-size: 14px;
          font-weight: 500;
          color: ${colors.black2};
          text-decoration: none;
          padding: 10px 0;
          border-bottom: 1px solid ${colors.border1};
          transition: all 0.2s ease;
          text-indent: 10px;

          &:hover,
          &:focus {
            background: rgba(17, 182, 122, 0.18);
            color: ${colors.black1};
          }

          &.active {
            background: ${colors.red_bg};
            color: #ffffff;
            border-color: transparent;
          }
        }
      }
    }
  }

  @media (max-width: 575px) {
    .sidebar {
      width: 250px;
    }
  }
`;
